

/* BEGIN internal-65l-backpack-buyer-highlights-20260731 */
;(function () {
  var expected = ["Robust 900D polyester, a concealed zipper, secure KAM buckles, and an easy-access built-in rain cover provide water-repellent, abrasion-resistant durability.","MOLLE webbing, large side bags, a hidden top pocket, and bottom webbing straps expand storage for gear, a sleeping bag, or a floor mat.","Adjustable shoulder and chest straps, a height-adjustment back strap, 3D extra-thick breathable back padding, a top handle, and a padded waist belt (up to 60 in) support comfortable carry."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-65l-internal-frame-waterproof-backpack-rain-cover-included') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END internal-65l-backpack-buyer-highlights-20260731 */
